// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import './assets/scss/Theme.scss';
 
// import AdminLogin from './pages/auth/admin-login';
// import Routing from './routes/Routes';
// import DashBoard1 from './pages/dashboards/DashBoard1';
 
// function App() {
//         return (
//           <Router>
//             <Routes>
//               <Route path="/" element={<AdminLogin />} />
//               <Route path="/dashboard" element={<DashBoard1 />} /> 
//             </Routes>
//           </Router>
//         );
//        }
// export default App;

// ========================

// all routes
import Routes from './routes/Routes';
import './assets/scss/Theme.scss';
import { AuthProvider, AuthContext } from './context/AuthContext';
const App = () => {
    return <Routes />;
};
export default App;

// ========================

// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import { useRedux } from "./hooks";
// import { LayoutTypes, SideBarTypes } from "../src/constants";
// import { changeBodyAttribute } from "../src/utils";

// import TopWrapperSection from "./pages/pagelayout/topwarppersection";
// import BottomWrapperSection from "./pages/pagelayout/bottomwrappersection";

// import "./assets/scss/Theme.scss";

// import AdminLogin from "./pages/auth/admin-login";
// import DashBoard1 from "./pages/dashboards/DashBoard1";
// import EmployeeList from "./pages/apps/Contacts/List";
// import CreateEmployee from "./pages/apps/Employee/create-employee";
// import EmployeeDetailsview from "./pages/apps/Employee/employee-details";
// import Projects from "./pages/apps/Projects";
// import ProjectTaskList from "./pages/apps/Projects/projects-task";
// import TaskDetail from "./pages/apps/Tasks/Detail";
// import TaskListView from "./pages/apps/Tasks/Board/Task";
// import LeaveDetails from "./pages/apps/Employee/leave-details";
// import AddLeaveRequest from "./pages/apps/Employee/add-leave-request";

// function App() {
//     const { appSelector } = useRedux();
//     const {
//         layoutColor,
//         layoutWidth,
//         menuPosition,
//         leftSideBarTheme,
//         leftSideBarType,
//         showSidebarUserInfo,
//         topbarTheme,
//     } = appSelector((state) => ({
//         layoutColor: state.Layout.layoutColor,
//         layoutWidth: state.Layout.layoutWidth,
//         menuPosition: state.Layout.menuPosition,
//         leftSideBarTheme: state.Layout.leftSideBarTheme,
//         leftSideBarType: state.Layout.leftSideBarType,
//         showSidebarUserInfo: state.Layout.showSidebarUserInfo,
//         topbarTheme: state.Layout.topbarTheme,
//     }));

//     const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false);

//     useEffect(() => {
//         changeBodyAttribute("data-layout-mode", LayoutTypes.LAYOUT_VERTICAL);
//     }, []);

//     useEffect(() => {
//         changeBodyAttribute("data-layout-color", layoutColor);
//     }, [layoutColor]);

//     useEffect(() => {
//         changeBodyAttribute("data-layout-size", layoutWidth);
//     }, [layoutWidth]);

//     useEffect(() => {
//         changeBodyAttribute("data-leftbar-position", menuPosition);
//     }, [menuPosition]);

//     useEffect(() => {
//         changeBodyAttribute("data-leftbar-color", leftSideBarTheme);
//     }, [leftSideBarTheme]);

//     useEffect(() => {
//         changeBodyAttribute("data-leftbar-size", leftSideBarType);
//     }, [leftSideBarType]);

//     useEffect(() => {
//         changeBodyAttribute("data-topbar-color", topbarTheme);
//     }, [topbarTheme]);

//     useEffect(() => {
//         changeBodyAttribute("data-sidebar-user", showSidebarUserInfo);
//     }, [showSidebarUserInfo]);

//     const openMenu = () => {
//         setIsMenuOpened((prevState) => !prevState);

//         if (document.body) {
//             if (isMenuOpened) {
//                 document.body.classList.remove("sidebar-enable");
//             } else {
//                 document.body.classList.add("sidebar-enable");
//             }
//         }
//     };

//     const isCondensed: boolean = leftSideBarType === SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED;

//     return (
//         <Router>
//             <TopWrapperSection openMenu={openMenu} isCondensed={isCondensed}>
//                 <Routes>
//                     <Route path="/" element={<AdminLogin />} />
//                     <Route path="/dashboard" element={<DashBoard1 />} />
//                     <Route path="/apps/contacts/list" element={<EmployeeList />} />
//                     <Route path="/apps/add-employee" element={<CreateEmployee />} />
//                     <Route path="/apps/employee-profile" element={<EmployeeDetailsview />} />
//                     <Route path="/apps/employeeattendance" element={<EmployeeDetailsview />} />
//                     <Route path="/apps/projects" element={<Projects />} />
//                     <Route path="/apps/project-task" element={<ProjectTaskList />} />
//                     <Route path="/apps/tasks/details" element={<TaskDetail />} />
//                     <Route path="/apps/tasks-list-view" element={<TaskListView />} />
//                     <Route path="/apps/leave-details" element={<LeaveDetails />} />
//                     <Route path="/apps/add-leave-request" element={<AddLeaveRequest />} />
//                 </Routes>
//             </TopWrapperSection>
//             <BottomWrapperSection />
//         </Router>
//     );
// }

// export default App;
